import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SITE_NAME = 'PonPon!';
export const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://ponpon.app';
export const DEFAULT_DESCRIPTION =
  'Buy Japanese gachapon online in the USA. Spin real capsule toys instantly and ship your collection together with PonPon.';
export const DEFAULT_SOCIAL_IMAGE = '/assets/Background.png';

const toAbsoluteUrl = (value, fallback = SITE_URL) => {
  if (!value) {
    return fallback;
  }
  if (/^https?:\/\//i.test(value)) {
    return value;
  }
  const trimmed = value.startsWith('/') ? value : `/${value}`;
  return `${SITE_URL}${trimmed}`;
};

const Seo = ({
  title = `${SITE_NAME} | Online Gachapon`,
  description = DEFAULT_DESCRIPTION,
  canonical,
  image = DEFAULT_SOCIAL_IMAGE,
  type = 'website',
  noindex = false,
  jsonLd = [],
  children,
}) => {
  const structuredBlocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
  // Prefer explicit canonical; otherwise use current page URL so each route can be indexed.
  // In browser we have window; during SSR/static HTML we fallback to SITE_URL.
  const canonicalUrl = canonical
    ? toAbsoluteUrl(canonical)
    : typeof window !== 'undefined'
      ? window.location.origin + window.location.pathname
      : SITE_URL;
  const pageTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;
  const metaDescription = description || DEFAULT_DESCRIPTION;
  const imageUrl = toAbsoluteUrl(image, toAbsoluteUrl(DEFAULT_SOCIAL_IMAGE));

  return (
    <Helmet prioritizeSeoTags>
      <title>{pageTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:alt" content={`${SITE_NAME} promo image`} />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={pageTitle} />
      <meta property="twitter:description" content={metaDescription} />
      <meta property="twitter:image" content={imageUrl} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      {structuredBlocks.map((block, index) => (
        <script
          key={`jsonld-${index}`}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(block) }}
        />
      ))}
      {children}
    </Helmet>
  );
};

export default Seo;
